import { withErrorBoundary } from '@nile/components';
import { IndeterminateCheckbox } from '@nile/components/src/Components/SuperTable/SuperTable.js';
import { flexRender } from '@tanstack/react-table';
import { get } from 'lodash';
import { getCommonPinningStyles } from './TableHelpers';
import React from 'react';
// Component for <td> </td>

const DataCell = (props) => {
  const {
    row,
    defaultColumn,
    actions,
    editCellId,
    onGroupHeaderSelectionChange,
    maintainSelection,
    isRowSelected,
    checkBoxDisabledCheck,
    idKey,
    isRowHeaderSelected,
    isHeaderIndeterminate
  } = props;

  // If this is a group header, render only 2 columns (checkbox + content)
  if (row.original.isGroupHeader) {
    const cells = row.getVisibleCells();
    // Get the checkbox cell
    const checkboxCell = cells.find(
      (cell) =>
        cell.column.id === 'select' ||
        cell.column.columnDef.superIndex === 'check'
    );

    // Create a special content cell that spans the remaining columns
    const contentCell = checkboxCell ? cells[1] : cells[0]; // Assuming the second column has the group name
    if (checkboxCell && contentCell) {
      return (
        <>
          <td
            {...{
              key: checkboxCell.id,
              style: {
                width: checkboxCell.column.getSize(),
                borderTop: '1px solid #e7e7e7',
                borderBottom: '1px solid #e7e7e7',
                ...getCommonPinningStyles(checkboxCell.column)
              },
              id: 'group-header-checkbox'
            }}
          >
            {/* Use a custom checkbox for group headers */}
            <div>
              <IndeterminateCheckbox
                className={'ml-0'}
                onChange={(e) => onGroupHeaderSelectionChange(e, row, idKey)}
                row={row}
                checkBoxDisabledCheck={checkBoxDisabledCheck}
                superIndex={'check'}
                defaultValue={row.id}
                idKey={idKey}
                checked={isRowHeaderSelected(row)}
                indeterminate={isHeaderIndeterminate(row)}
              />
            </div>
          </td>
          <td
            {...{
              key: contentCell.id,
              colSpan: cells.length - 1,
              style: {
                fontWeight: 'bold',
                borderTop: '1px solid #e7e7e7',
                borderBottom: '1px solid #e7e7e7'
              },
              id: 'group-header-content'
            }}
          >
            <div className="group-header-content fx g10 fw">
              {row.original.groupName}
              {row.original.showAdditionalHeaderProperties &&
                row.original.additionalHeaderProperties.map((property) => {
                  const Prop = property.component;
                  if (Prop) {
                    return <Prop headerData={row.original} />;
                  }
                  return null;
                })}
            </div>
          </td>
        </>
      );
    }
    if (!checkboxCell && !!contentCell) {
      return (
        <td
          {...{
            key: contentCell.id,
            colSpan: cells.length,
            style: {
              fontWeight: 'bold',
              borderTop: '1px solid #e7e7e7',
              borderBottom: '1px solid #e7e7e7'
            },
            id: 'group-header-content'
          }}
        >
          <div className="group-header-content fx g10 fw">
            {row.original.groupName}
            {row.original.showAdditionalHeaderProperties &&
              row.original.additionalHeaderProperties.map((property) => {
                const Prop = property.component;
                if (Prop) {
                  return <Prop headerData={row.original} />;
                }
                return null;
              })}
          </div>
        </td>
      );
    }
  }

  // Regular row rendering for non-group headers
  return row.getVisibleCells().map((cell) => {
    const cellContext = cell.getContext();
    let transformedCell = { ...cell.getContext() };
    const accessor =
      cellContext.cell.column.columnDef?.accessorKey ||
      cellContext.cell.column.columnDef?.accessor;

    let cellValue = null; // Can remove this if the fix is rolled out by tenstackTable

    if (accessor && get(row?.original, accessor.split('.'), null)) {
      cellValue = cell.getValue();
    }

    transformedCell = {
      ...transformedCell,
      cell: {
        ...transformedCell.cell,
        value: cellValue,
        column: {
          ...transformedCell.cell.column,
          ...transformedCell.cell.column.columnDef
        },
        row: {
          ...transformedCell.cell.row,
          values: transformedCell.row.original
        },
        key: cellValue
      },
      column: transformedCell.cell.column.columnDef,
      actions: actions,
      cellId: `$${transformedCell.cell.row?.id}-${transformedCell.cell.column.columnDef?.superIndex}`,
      editCellId: editCellId
    };

    const pinningStyles = getCommonPinningStyles(cell.column) || {};

    return (
      <>
        <td
          {...{
            key: cell.id,
            style: {
              width: cell.column.getSize(),
              ...pinningStyles
            }
          }}
        >
          {flexRender(
            cell.column.columnDef.type
              ? defaultColumn[cell.column.columnDef.type]
              : cell.column.columnDef.cell,
            transformedCell
          )}
        </td>
      </>
    );
  });
};

export default React.memo(withErrorBoundary(DataCell));
